/* Copyright (c) 2017 Backpack Health LLC */

import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import './SelectInput.css';

import DropdownArrow from './DropdownArrow';
import { colorClassNames } from '../../../styles/styleUtility';

interface Props {
  htmlId: string;
  value?: any;
  displayValue: any;
  onChange(value: any): void;
  onBlur?(): void;
  onFocus?(): void;
  color?: string;
  options: any;
  hint?: any;
  label?: any;
}

class SelectInput extends React.Component<Props, {}> {
  render() {
    return (
      <div className="cmp-selectinput">
        <label htmlFor={this.props.htmlId}>{this.props.label}</label>

        <div className="cmp-selectinput-content">
          <div className="cmp-selectinput-value">
            {this.props.displayValue}

            <div className="cmp-selectinput-icon">
              <DropdownArrow />
            </div>
          </div>

          <select
            name={this.props.htmlId}
            id={this.props.htmlId}
            value={this.props.value}
            onFocus={this.props.onFocus}
            onBlur={this.props.onBlur}
            onChange={(e) => this.props.onChange(e.target.value)}
          >
            {this.props.options}
          </select>
        </div>

        <div className="cmp-selectinput-caption">
          {this.props.hint}
        </div>
      </div>
    );
  }

  static defaultProps = {
    color: 'middle-gray',
  };
}

export default SelectInput;
